import {
  ADD_AD,
  ADD_AD_ERROR,
  ADD_AD_SUCCESS,
  GET_ADS,
  GET_ADS_ERROR,
  GET_ADS_SELECT_LIST_SUCCESS,
  GET_ADS_SUCCESS,
  GET_AD,
  GET_AD_ERROR,
  GET_AD_SUCCESS,
  TOGGLE_AD_MODAL,
  UPDATE_AD,
  UPDATE_AD_ERROR,
  UPDATE_AD_SUCCESS,
  UPLOAD_AD_BANNER,
  UPLOAD_AD_BANNER_SUCCESS,
  UPLOAD_AD_BANNER_ERROR,
} from "./actionTypes";

const initialState = {
  // ads
  loadingAds: false,
  loadingAdsSuccess: false,
  loadingAdsError: null,
  ads: {},
  // add ad
  ad: {},
  addAdLoading: false,
  addAdError: null,
  addAdSuccess: false,
  // get ad
  getAdLoading: false,
  getAdError: null,
  getAdSuccess: null,
  // update ad
  updateAdLoading: false,
  updateAdError: null,
  updateAdSuccess: false,
  // icon
  uploadingAdBanner: false,
  uploadingAdBannerSuccess: null,
  uploadingAdBannerError: null,
  uploadCount: null,
  // select list
  adsSelectList: [],
};

const ads = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADS:
      state = {
        ...state,
        updateAdSuccess: false,
        addAdSuccess: false,
        uploadCount: null,
        loadingAdsError: null,
        loadingAdsSuccess: false,
        loadingAds: true,
        ads: [],
        ad: {},
      };
      break;
    case GET_ADS_SUCCESS:
      state = {
        ...state,
        loadingAds: false,
        loadingAdsSuccess: true,
        loadingAdsError: null,
        ads: action.payload,
      };
      break;
    case GET_ADS_ERROR:
      state = {
        ...state,
        loadingAds: false,
        loadingAdsError: action.payload,
        loadingAdsSuccess: false,
        ads: [],
      };
      break;
    case TOGGLE_AD_MODAL:
      state = {
        ...state,
        uploadCount: null,
        ad: {},
      };
      break;
    case ADD_AD:
      state = {
        ...state,
        addAdLoading: true,
        addAdError: null,
        addAdSuccess: false,
        uploadCount: null,
      };
      break;
    case ADD_AD_SUCCESS:
      state = {
        ...state,
        addAdLoading: false,
        addAdError: null,
        addAdSuccess: true,
        ad: {},
      };
      break;
    case ADD_AD_ERROR:
      state = {
        ...state,
        addAdLoading: false,
        addAdError: action.payload,
        addAdSuccess: false,
      };
      break;
    case GET_AD:
      state = {
        ...state,
        ad: {},
        getAdLoading: true,
        getAdError: null,
      };
      break;
    case GET_AD_SUCCESS:
      state = {
        ...state,
        ad: action.payload,
        getAdLoading: false,
      };
      break;
    case GET_AD_ERROR:
      state = {
        ...state,
        getAdError: action.payload,
        getAdLoading: false,
      };
      break;
    case UPDATE_AD:
      state = {
        ...state,
        updateAdLoading: true,
        updateAdError: null,
        updateAdSuccess: false,
      };
      break;
    case UPDATE_AD_SUCCESS:
      state = {
        ...state,
        updateAdLoading: false,
        updateAdError: false,
        updateAdSuccess: true,
      };
      break;
    case UPDATE_AD_ERROR:
      state = {
        ...state,
        updateAdLoading: false,
        updateAdError: action.payload,
        updateAdSuccess: false,
      };
      break;
    case UPLOAD_AD_BANNER:
      state = {
        ...state,
        uploadingAdBanner: true,
        uploadCount: state.uploadCount ? state.uploadCount + 1 : 0 + 1,
      };
      break;
    case UPLOAD_AD_BANNER_SUCCESS: {
      if (action.payload.lang === "en") {
        var bannerIds = [];
        if (
          state &&
          state.ad &&
          state.ad.bannerIds &&
          state.ad.bannerIds.length
        ) {
          bannerIds = [...state.ad.bannerIds, action.payload.banner.id];
        } else {
          bannerIds = [action.payload.banner.id];
        }
        state = {
          ...state,
          uploadingAdBanner: false,
          uploadingAdBannerSuccess: true,
          ad: {
            ...state.ad,
            bannerIds: bannerIds,
          },
          uploadCount: state.uploadCount - 1,
        };
      }
      if (action.payload.lang === "ar") {
        var arabicBannerIds = [];
        if (
          state &&
          state.ad &&
          state.ad.arabicBannerIds &&
          state.ad.arabicBannerIds.length
        ) {
          arabicBannerIds = [
            ...state.ad.arabicBannerIds,
            action.payload.banner.id,
          ];
        } else {
          arabicBannerIds = [action.payload.banner.id];
        }
        state = {
          ...state,
          uploadingAdBanner: false,
          uploadingAdBannerSuccess: true,
          ad: {
            ...state.ad,
            arabicBannerIds: arabicBannerIds,
          },
          uploadCount: state.uploadCount - 1,
        };
      }
      break;
    }
    case UPLOAD_AD_BANNER_ERROR:
      state = {
        ...state,
        uploadingAdBanner: false,
        uploadingAdBannerError: action.payload,
        uploadingAdBannerSuccess: false,
        uploadCount: state.uploadCount - 1,
      };
      break;
    case GET_ADS_SELECT_LIST_SUCCESS:
      state = {
        ...state,
        adsSelectList: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ads;
